import type { Error } from '../types';
import { PO_BOX_ADDRESS_REGEX } from '../utils/regex';

import { TXTCLI_PO_Box_addresses_are_not_permi_ELL } from './poBoxAddressNotAllowed.messages';

export const poBoxAddressNotAllowed = (value: string): Error => ({
  valid: !PO_BOX_ADDRESS_REGEX.test(value),
  message: TXTCLI_PO_Box_addresses_are_not_permi_ELL
});
